module.exports = __webpack_public_path__ + "static/img/2.76fbdb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user_image/2.jpg
// module id = gDet
// module chunks = 11